import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/projects",
    name: "Projects",
    component: () =>
      import(/* webpackChunkName: "Projects" */ "../views/Projects.vue"),
  },
  {
    path: "/projects/:id",
    name: "Organization",
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "../views/Organization.vue"
      ),
  },
  {
    path: "/embed/:id/:country",
    name: "OrganizationEmbed",
    component: () =>
      import(
        /* webpackChunkName: "organization_embed" */ "../views/OrganizationEmbed.vue"
      ),
  },
  {
    path: "/about-us",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/about-us-he",
    name: "AboutHeb",
    component: () =>
      import(/* webpackChunkName: "about-heb" */ "../views/AboutHeb.vue"),
  },
  {
    path: "/אודות-קרן-נאמן",
    name: "AboutHebRoute",
    component: () =>
      import(/* webpackChunkName: "about-heb" */ "../views/AboutHeb.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Contact.vue"),
  },
  {
    path: "/services",
    name: "Services",
    component: () =>
      import(/* webpackChunkName: "services" */ "../views/Services.vue"),
  },
  {
    path: "/join-us",
    name: "Join",
    component: () => import(/* webpackChunkName: "join" */ "../views/Join.vue"),
  },
  {
    path: "/how-to-donate",
    name: "HowToDonate",
    component: () =>
      import(/* webpackChunkName: "howToDonate" */ "../views/HowToDonate.vue"),
  },
  {
    path: "/thank_you",
    name: "ThankYou",
    component: () =>
      import(/* webpackChunkName: "ThankYou" */ "../views/ThankYou.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  window.scrollTo({ top: 0, behavior: "smooth" });
  next();
});

export default router;
